import { debounce } from "@remarkablenet/utils";

export default (context: HTMLElement | Document = document) => {
    const readMoreContainers = context.querySelectorAll<HTMLDivElement>('.read-more__container');

    for (const container of readMoreContainers) {
      const readmoreCheckBox = container.querySelector<HTMLInputElement>('input[name="read-more"]');

      readmoreCheckBox.addEventListener('change', (e: Event) => {
        const isChecked = (e.target as HTMLInputElement).checked;


        container.classList.toggle('is-active', isChecked);
      });

      shouldHideEl(container);

      window.addEventListener('resize', debounce(() => shouldHideEl(container), 100));
    }
  };

const shouldHideEl = (readMoreContainer: HTMLDivElement) => {
  const currentScrollHeight = readMoreContainer.querySelector<HTMLDivElement>('.read-more-description')?.scrollHeight;

  readMoreContainer.classList.toggle('is-hiding', currentScrollHeight <= 72);
};